import { render, staticRenderFns } from "./mCategoryView3.vue?vue&type=template&id=b003fb3c&scoped=true"
import script from "./mCategoryView3.vue?vue&type=script&lang=js"
export * from "./mCategoryView3.vue?vue&type=script&lang=js"
import style0 from "./mCategoryView3.vue?vue&type=style&index=0&id=b003fb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b003fb3c",
  null
  
)

export default component.exports